export default __webpack_public_path__ + "static/media/4-mini.b574dd32.webp";